import React from 'react'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import LuxuryPlusPriceGuard from 'loyalty/components/LuxuryPlusPriceGuard'
import PriceStackLoyaltyProminentPrice from 'components/Luxkit/PricePoints/Loyalty/PriceStackLoyaltyProminentPrice'

interface Props {
  captionText: string;
  memberPrice: number;
  price: number;
  value: number;
  offer: App.BedbankOffer | App.Offer | App.OfferSummary
  showValueDiscount: boolean;
  discount?: number;
  taxesAndFees?: number | 'inclusive' | 'exclusive';
  saleUnit?: string;
}

function BaseOfferPriceContent({ offer, captionText, memberPrice, price, value, saleUnit, taxesAndFees, showValueDiscount, discount }: Props) {
  return (
    <>
      <PriceRowPriceCaption>{captionText}</PriceRowPriceCaption>
      <LuxuryPlusPriceGuard
        showMemberPrice={memberPrice > 0}
        fallbackPrice={
          <PriceRowPrice
            price={price}
            size="S"
            saleUnit={saleUnit ?? 'total'}
            taxesAndFees={taxesAndFees ?? 'exclusive'}
          />
        }
      >
        <PriceStackLoyaltyProminentPrice
          size="S"
          nonMemberPrice={price}
          memberPrice={memberPrice}
          saleUnit={offer.saleUnit}
          taxesAndFees={taxesAndFees ?? 'exclusive'}
          orientation="vertical"
          horizontalAlign="start"
        />
      </LuxuryPlusPriceGuard>
      {showValueDiscount && <PriceRowValueDiscountWithCaption
        size="M"
        value={Math.ceil(value)}
        discountPercentage={discount}
      />}
    </>
  )
}

export default BaseOfferPriceContent
